import { useCallback, useEffect, useMemo, useState } from "react";
import { useDispatch } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import {
  delete_seller,
  get_sellers,
  update_user,
} from "../../reduxData/user/userAction";
import GavelIcon from "@mui/icons-material/Gavel";
import HandshakeIcon from "@mui/icons-material/Handshake";
import { getCountryCallingCode } from "react-phone-number-input";
import { Box, Input } from "@mui/joy";
import CustomPagination from "../CustomPagination";
import EmptyData from "../EmptyData";
import moment from "moment";
import DeleteContent from "../../Modals/DeleteContent";
import { useSelector } from "react-redux";
import UserDetails from "../UserDetails";
import DeletePopup from "../../Modals/DeletePopup";
import { jsonToCSV, downloadCSV } from "../../utils/DownloadCSV";
import { columns } from "./utils/Columns";
import FilterModal from "./ReportFilterData";
import "./Seller.css";

const SellerManagement = ({ allUsers, isLoading }) => {
  const [userManagement, setUserManagement] = useState(null);
  const [loading, setLoading] = useState(false);
  const [filter, setFilter] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [isDelete, setIsDelete] = useState(false);
  const [statusFilter, setStatusFilter] = useState("All");
  const [editData, setEditData] = useState(null);
  const [total, setTotal] = useState(0);
  const [resetPage, setResetPage] = useState(false);
  const [totalUsers, setTotalUsers] = useState("");
  const { user } = useSelector((state) => state.auth);
  const [show, setShow] = useState(false);
  const [data, setData] = useState(null);
  const { user: userRole } = useSelector((state) => state?.auth);
  const [filterModal, setFilterModal] = useState(false);
  const [sortBy, setSortBy] = useState("");

  const [openDeletePopup, setOpenDeletePopup] = useState(false);
  const [sellerId, setSellerId] = useState("");

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const fetchData = async (page = currentPage, rows = perPage) => {
    try {
      const data = await get_sellers({
        value: filter,
        page,
        rows,
        email,
        sortBy,
      });
      setUserManagement(data?.data);
      setTotalUsers(data?.pagination?.total);
      setTotal(data?.total || 0);
      window.scrollTo({ top: 0, behavior: "instant" });
    } catch (error) {
      console.error("Error fetching user data:", error);
    }
  };

  useEffect(() => {
    fetchData();
  }, [currentPage, perPage, name, email, statusFilter, filter, sortBy]);

  const changeDOJFormat = (data) => {
    const joinDate = moment(data).format("MM/DD/YYYY");
    return joinDate;
  };

  const handleDelete = async (item) => {
    const data = {
      is_deactive: item?.is_deactive ? false : true,
    };
    const message = item?.is_deactive
      ? "User Active Successfully"
      : "User In-Active Successfully";
    const isEdit = await update_user(
      item?.id,
      data,
      navigate,
      localStorage.getItem("token"),
      dispatch,
      true,
      message
    );
    navigate("/seller");
    if (isEdit) {
      fetchData();
      setUserManagement(data?.data);
    }
  };

  const deleteSeller = async () => {
    const res = await delete_seller(sellerId);
    setSellerId("");
    setOpenDeletePopup(false);
    if (res) {
      fetchData();
    }
  };

  const handleExportAll = async (startDate, endDate) => {
    //       {value,
    // page,
    // rows,
    // email,
    // startDate,
    // endDate
    // }
    try {
      setLoading(true);
      const res = await get_sellers({
        filter,
        page: 1,
        rows: totalUsers,
        startDate,
        endDate,
      });
      console.log("Export response:", res);
      console.log("Export sellers:", res?.data);
      console.log(columns);
      const sellers = res?.data || [];
      const csv = jsonToCSV(sellers, columns);
      downloadCSV(csv, `seller-management-${Date.now()}.csv`);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const handleSortBy = useCallback((e) => {
    const value = e.target.value;
    setSortBy(value);
  }, []);

  const canViewActions = useMemo(
    () =>
      (user?.role === "staff" && user?.permission?.p_users > 1) ||
      user?.role !== "staff",
    [user]
  );

  const canToggleStatus = useMemo(
    () =>
      (user?.role === "staff" && user?.permission?.p_users > 2) ||
      user?.role !== "staff",
    [user]
  );

  const hasRows =
    Array.isArray(userManagement) && userManagement.length > 0;

  return (
    <div className="container">
      <Box className="flex-md-row flex-column gap-2 d-flex mb-3 align-items-md-center justify-content-between">
        <div>
          <h3 className="mb-0 fw-600">Seller Management</h3>
          <span className="text-muted">
            {totalUsers || 0} {Number(totalUsers) === 1 ? "seller" : "sellers"}
          </span>
        </div>
      </Box>

      <div className="users__toolbar mb-3">
        <div className="row g-3 align-items-center">
          <div className="col-lg-4 col-md-6">
            <Input
              id="emailInput"
              type="text"
              placeholder="Search by email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </div>

          <div className="col-lg-8 col-md-6">
            <div className="d-flex flex-wrap gap-2 justify-content-md-end align-items-center">
              <div className="btn-group gap-2" role="group">
                <button
                  type="button"
                  className={`seller-pill text-nowrap rounded-pill px-3 py-2 ${
                    filter ? "active" : ""
                  }`}
                  onClick={() => {
                    setFilter(true);
                    setResetPage(true);
                  }}
                >
                  Admin Verified
                </button>
                <button
                  type="button"
                  className={`seller-pill text-nowrap rounded-pill px-3 py-2 ${
                    !filter ? "active" : ""
                  }`}
                  onClick={() => {
                    setFilter(false);
                    setResetPage(true);
                  }}
                >
                  Not Verified
                </button>
              </div>

              <select
                className="seller-sort-select"
                value={sortBy}
                defaultValue={""}
                onChange={handleSortBy}
              >
                <option value="" disabled>Sort By</option>
                <option value="bids">Bids </option>
                <option value="ask">Asks</option>
              </select>

              <button
                className="btn btn-dark "
                disabled={loading}
                onClick={() => setFilterModal(true)}
              >
                {loading ? "Exporting…" : "Export All"}
              </button>
            </div>
          </div>
        </div>
      </div>

      <div className="bxw-table-wrap">
        <div className="table-responsive">
          <table className="table bxw-table table-hover">
            <thead>
              <tr>
                <th scope="col">Sr. No.</th>
                <th scope="col">Account Id</th>
                <th scope="col">Name</th>
                <th scope="col">Email</th>
                <th scope="col">Role</th>
                <th scope="col">Phone No.</th>
                <th scope="col" className="text-center">
                  Date of Joining
                </th>
                <th scope="col" className="text-center">
                  Status
                </th>
                <th scope="col" className="text-center">
                  Processing Fee
                </th>
                {canViewActions && (
                  <th scope="col" className="text-center">
                    Action
                  </th>
                )}
              </tr>
            </thead>
            <tbody>
              {hasRows ? (
                userManagement.map((data, index) => (
                  <tr key={data?.id ?? index}>
                    <td>{(currentPage - 1) * perPage + index + 1}.</td>
                    <td>
                      <span className="seller-account-id">
                        {data?.account_id || "-"}
                      </span>
                    </td>
                    <td>
                      <div
                        className={
                          data?.user_name
                            ? "w-fit-content hover-underline fw-500"
                            : "fw-500"
                        }
                      >
                        {`${data?.shipping_addresses?.[0]?.first_name || ""} ${
                          data?.shipping_addresses?.[0]?.last_name || ""
                        }`.trim() || "-"}
                      </div>
                    </td>
                    <td>{data?.email}</td>
                    <td>{data?.role}</td>
                    <td>
                      {data?.shipping_addresses?.[0]?.phoneNumber
                        ? `${
                            data?.shipping_addresses?.[0]?.country
                              ? `+${getCountryCallingCode(
                                  data?.shipping_addresses?.[0]?.country
                                )}`
                              : ""
                          } ${data?.shipping_addresses?.[0]?.phoneNumber}`
                        : "-"}
                    </td>
                    <td className="text-center text-nowrap">
                      {changeDOJFormat(data.created_at)}
                    </td>
                    <td className="text-center">
                      <span
                        className={`seller-badge ${
                          data?.is_deactive ? "is-inactive" : "is-active"
                        }`}
                      >
                        {data?.is_deactive ? "In-active" : "Active"}
                      </span>
                    </td>
                    <td className="text-center">
                      <span className="seller-fee-chip">
                        {`${data?.transaction_fee ?? 0}%`}
                      </span>
                    </td>
                    {canViewActions && (
                      <td className="text-center">
                        <div className="d-flex gap-1 align-items-center justify-content-center">
                          <span
                            className="btn btn-sm btn-outline-primary d-flex align-items-center gap-1"
                            onClick={() =>
                              navigate(`/buyer-bid?search=${data?.email}`)
                            }
                          >
                            <GavelIcon fontSize="small" />
                            Bids
                            {data?.total_bids != null &&
                              ` (${data?.total_bids})`}
                          </span>
                          {filter && (
                            <span
                              className="btn btn-sm btn-outline-success d-flex align-items-center gap-1"
                              onClick={() =>
                                navigate(`/seller-ask?search=${data?.email}`)
                              }
                            >
                              <HandshakeIcon fontSize="small" />
                              Asks
                              {data?.total_ask != null &&
                                ` (${data?.total_ask})`}
                            </span>
                          )}
                          <Link
                            className="navbar-brand mx-1"
                            title="View seller"
                            to={`/seller/${data?.id}`}
                          >
                            <i className="bi bi-eye fs-5"></i>
                          </Link>

                          {canToggleStatus && (
                            <div className="form-check form-switch switch-large mb-0">
                              <input
                                className="form-check-input"
                                type="checkbox"
                                role="switch"
                                title={
                                  data?.is_deactive
                                    ? "Activate seller"
                                    : "Deactivate seller"
                                }
                                checked={!data?.is_deactive}
                                onChange={() => handleDelete(data)}
                              />
                            </div>
                          )}
                        </div>
                      </td>
                    )}
                  </tr>
                ))
              ) : (
                <EmptyData />
              )}
            </tbody>
          </table>
        </div>
      </div>

      <div className="mt-3">
        {totalUsers > 0 && (
          <CustomPagination
            total={totalUsers}
            onPageChange={(page, perPage) => {
              setCurrentPage(page);
              setPerPage(perPage);
            }}
            resetPage={resetPage}
          />
        )}
      </div>

      <UserDetails
        show={show}
        handleClose={() => {
          setData(null);
          setShow(false);
        }}
        user={data}
      />
      <DeleteContent
        show={isDelete}
        handleClose={() => {
          setEditData(null);
          setIsDelete(false);
        }}
        data={editData}
        heading={"User"}
        otherLine={"User"}
        isFaq={"userDelete"}
      />
      {openDeletePopup && (
        <DeletePopup
          open={openDeletePopup}
          setOpen={setOpenDeletePopup}
          handleDelete={deleteSeller}
          label="Are you sure , you want to delete the Seller"
        />
      )}
      {filterModal && (
        <FilterModal
          filterModal={filterModal}
          setFilterModal={setFilterModal}
          handleExportAll={handleExportAll}
        />
      )}
    </div>
  );
};

export default SellerManagement;
